import { EdelError } from "./interfaces/errors";
import { accountDetails } from "@frameworks/web/di";
import * as URLConfig from "@frameworks/web/config/domain";
const TOKEN = "jwt_token";
const GAUTH = "Gauth";
const CONTENT_TYPE = "Content-Type";
const CONTET_TYPE_VALUE = "application/json";
const APP_ID_KEY = "AppIdKey";
const APP_ID_VALUE = URLConfig.config.appIdKey;
const SOURCE = "Source";
const SOURCE_VALUE = "EDEL";
const AUTHORIZATION = "Authorization";
const PLATFORM = "platform";
const PLATFORM_VALUE = "admin ";
class Http {
    constructor(autorize, storage) {
        this.autorize = autorize;
        this.localStorage = storage;
    }
    getDownloadableFile(blob, disposition) {
        var filename = "file";
        if (disposition && disposition.indexOf("attachment") !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) {
                filename = matches[1].replace(/['"]/g, "");
            }
            return new File([blob], filename);
        }
    }
    async makeApiCall(requestOption) {
        const option = {
            method: requestOption.method,
            signal: requestOption.signal,
        };
        await this.appendHeaders(requestOption, option);
        if (requestOption === null || requestOption === void 0 ? void 0 : requestOption.body)
            option.body = JSON.stringify(requestOption.body);
        return fetch(requestOption.url, option)
            .then(async (response) => {
            await this.throwErrorIfResponseIsNotOk(response);
            return response;
        })
            .then(async (res) => {
            const contentType = res.headers.get(CONTENT_TYPE);
            const ewjwt = res.headers.get("ewjwt");
            const GAuth = res.headers.get("GAuth");
            if (contentType == "application/force-download") {
                const disposition = res.headers.get("Content-Disposition");
                const blob = await res.blob();
                const file = this.getDownloadableFile(blob, disposition);
                return Promise.resolve(file);
            }
            if (ewjwt && ewjwt !== "") {
                let ewJwtToken = ewjwt.split(" ");
                this.localStorage.set(TOKEN, ewJwtToken[1]);
            }
            this.GuestAuthSession(GAuth);
            const parsedObject = await res.json();
            return parsedObject;
        })
            .catch(async (reason) => {
            try {
                if (reason instanceof DOMException &&
                    reason.code === DOMException.ABORT_ERR) {
                    throw new EdelError(0, {
                        status: false,
                        error: {
                            errorCode: DOMException.ABORT_ERR.toString(),
                            actionCode: "0",
                            errorMessage: reason.message,
                        },
                    });
                }
                throw reason;
            }
            catch (error) {
                throw new EdelError(error.getHttpCode(), {
                    status: error.getStatus(),
                    error: {
                        errorCode: error.getErrorCode() || error.getErrCd(),
                        actionCode: error.getActionCode(),
                        errorMessage: error.getErrorMessageOrErrMsg(),
                    },
                });
            }
        });
    }
    GuestAuthSession(GAuth) {
        if (GAuth && GAuth !== "")
            this.localStorage.set(GAUTH, GAuth);
    }
    async appendHeaders(requestOption, option) {
        const authToken = await this.autorize.getAuthToken();
        const gauthToken = await this.localStorage.get(GAUTH);
        const headers = new Headers();
        headers.append(CONTENT_TYPE, CONTET_TYPE_VALUE);
        requestOption.avoidAppID ? null : headers.append(APP_ID_KEY, APP_ID_VALUE);
        if (!requestOption.avoidSOURCE)
            headers.append(SOURCE, SOURCE_VALUE);
        const lgnSrc = await accountDetails.getLoginSrc();
        if (lgnSrc && lgnSrc === "nesttrader") {
            headers.append(PLATFORM, PLATFORM_VALUE);
        }
        if ((requestOption === null || requestOption === void 0 ? void 0 : requestOption.getGauth) && gauthToken)
            headers.append(GAUTH, gauthToken);
        if (authToken && !requestOption.avoidAuthToken) {
            headers.append(AUTHORIZATION, authToken);
        }
        if (requestOption === null || requestOption === void 0 ? void 0 : requestOption.headers) {
            requestOption === null || requestOption === void 0 ? void 0 : requestOption.headers.forEach((key, value) => {
                headers.append(value, key);
            });
        }
        option.headers = headers;
    }
    async throwErrorIfResponseIsNotOk(response) {
        if (!response.ok || response.status === 222) {
            let errorParams = null;
            try {
                errorParams = await response.json();
                if (response.status === 401) {
                    await this.localStorage.remove(TOKEN);
                    await this.localStorage.remove("acc_data");
                }
            }
            catch (error) {
                console.error("Parsing failed for error body");
            }
            throw new EdelError(response.status, errorParams);
        }
    }
    async request(requestOption, shoudldParseResponse = true) {
        const authToken = await this.autorize.getAuthToken(requestOption.isBearerToken);
        const option = { method: requestOption.method };
        const headers = new Headers();
        headers.append(CONTENT_TYPE, CONTET_TYPE_VALUE);
        if (!requestOption.isBearerToken)
            headers.append(APP_ID_KEY, APP_ID_VALUE);
        headers.append(SOURCE, SOURCE_VALUE);
        if (requestOption.isBearerToken) {
            headers.append(PLATFORM, window.localStorage.getItem("isImpersonated")
                ? "rm"
                : window.localStorage.getItem("lgnSrc") === "android-phone"
                    ? "android"
                    : window.localStorage.getItem("lgnSrc") === "iphone"
                        ? "ios"
                        : window.localStorage.getItem("lgnSrc") === "X"
                            ? "tx3"
                            : "WEB");
        }
        if (authToken && !requestOption.avoidAuthToken) {
            headers.append(AUTHORIZATION, authToken);
        }
        if (requestOption === null || requestOption === void 0 ? void 0 : requestOption.headers) {
            requestOption === null || requestOption === void 0 ? void 0 : requestOption.headers.forEach((key, value) => {
                headers.append(value, key);
            });
        }
        option.headers = headers;
        if (requestOption === null || requestOption === void 0 ? void 0 : requestOption.body)
            option.body = JSON.stringify(requestOption.body);
        return fetch(requestOption.url, option)
            .then(async (response) => {
            if (!response.ok) {
                //http : 400-499
                await this.throwErrorIfResponseIsNotOk(response);
            }
            return response;
        })
            .then((res) => {
            if (shoudldParseResponse) {
                return res.json();
            }
            if (res.status === 200 ||
                res.status === 201 ||
                res.status === 202 ||
                res.status === 222)
                return res;
            else
                console.log("Error", res);
        });
        // .catch((error) => {
        //   //http : 500-599
        //   console.log("https", error);
        //   // throw new Error("response.statusText");
        //   return error;
        // });
    }
}
export default Http;
